import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import Button from '../common/inputs/button';
import { Link } from 'react-router-dom';
import Constants from '../../../definitions/constants';

const CalculateButton = props => {
  const {
    loadingCalculate,
    handleCalculate,
    handleShowHistory,
    handleExportBiReports,
    handleReportFilesPopup,
    handleClickMenuItem,
    calculateDisabled,
    periodId
  } = props;
  return (
    <div className="calculation_section calculate_button_wrapper">
      <h3>{<FormattedMessage id="periodAdmin.calculationButtonTitle"/>}</h3>
      <Button
        disabled={loadingCalculate || calculateDisabled}
        loading={loadingCalculate}
        onClick={handleCalculate}
        labelLocale={<FormattedMessage id="periodAdmin.calculateButtonLabel"/>}
      />
      <a 
        onClick={(loadingCalculate || calculateDisabled) ? null : handleCalculate}
        data-debug="true"
        className={"calculate_debug_link" + ((loadingCalculate || calculateDisabled) ? " calculate_debug_link_disabled" : "")}
      >
        {<FormattedMessage id="periodAdmin.calculateDebugLink"/>}
      </a>
      <a onClick={handleShowHistory}>
        {<FormattedMessage id="periodAdmin.calculationHistoryLink"/>}
      </a>
      <Link data-route={Constants.app.routes.calculationsHistory} to={Constants.app.routes.calculationsHistory + "/" + periodId} onClick={handleClickMenuItem}>
        <FormattedMessage id="periodAdmin.calculationsDetailLink"/>
      </Link>
      <a onClick={handleExportBiReports}>
        {<FormattedMessage id="periodAdmin.exportBiReportsPopupLink"/>}
      </a>
      <a onClick={handleReportFilesPopup}>
        {<FormattedMessage id="periodAdmin.reportFilesPopup"/>}
      </a>      
    </div>
  );
};

export default CalculateButton;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/calculateButton.jsx